import React, { FC, ReactElement } from "react";
import { Button, Divider } from "antd";
import "./DropDownActions.scss";

type Props = {
  children?: ReactElement;
  handleOkClick: () => void;
  handleSelectAllClick?: () => void;
  selectAllText?: string;
};

const DropdownActions: FC<Props> = ({
  children,
  handleOkClick,
  handleSelectAllClick,
  selectAllText,
}) => {
  return (
    <>
      {children}
      {children ? <Divider className="dropdown-actions__divider" /> : null}
      <div className="dropdown-actions__buttons">
        {handleSelectAllClick ? (
          <Button
            type="link"
            className="dropdown-actions__select-all"
            onClick={handleSelectAllClick}
            onMouseDown={(e) => e.preventDefault()}
            size="small"
          >
            {selectAllText}
          </Button>
        ) : null}
        <Button
          type="primary"
          onClick={handleOkClick}
          onMouseDown={(e) => e.preventDefault()}
          size="small"
        >
          OK
        </Button>
      </div>
    </>
  );
};

export default DropdownActions;
